import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

interface Condition {
  column: string;
  operator: string;
  value: string;
}
export interface objectListDialogData {
  objectList:[],
  Query:string,
  fromJSIPFormulaBuilder?:boolean
}
interface ConditionGroup {
  type: 'AND' | 'OR';
  conditions: Condition[];
  groups: ConditionGroup[];
}

@Component({
    selector: 'app-sql-editor-popup',
    templateUrl: './sql-editor-popup.component.html',
    styleUrls: ['./sql-editor-popup.component.scss'],
    standalone: false
})
export class SqlEditorPopupComponent implements OnInit {
  rootGroup: ConditionGroup = {
    type: 'AND',
    conditions: [],
    groups: []
  };
  backgroundColorButton = "";
  allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  selectedTables: string[] = [];
  selectedColumns: any[] = [];
  selectedConditions: any[] = [];
  selectedJoins: any[] = [];
  selectedGroupByColumns: string[] = [];
  useGroupConcat: boolean = false;
  groupConcatColumn: string = '';
  backgroundColorScreen;
  buttonColor;
  selectedUnions: any[] = [];
  selectedSubqueries: any[] = [];

  tables = ['CASE_DEATH', 'CASE_DEATH_J', 'QUALIFIED_CASES', 'CASE_NEONATES_FINAL', 'Codelist_Mapping'];
  columns = {
    CASE_DEATH: ['CASE_NUM', 'DEATH_DATE', 'PATIENT_ID'],
    CASE_DEATH_J: ['CASE_NUM', 'DEATH_DATE', 'PATIENT_ID'],
    QUALIFIED_CASES: ['CASE_NUM', 'SOURCE'],
    CASE_NEONATES_FINAL: ['CASE_NUM', 'CASE_ID', 'BIRTH_TYPE_ID'],
    Codelist_Mapping: ['CODELIST_NAME', 'Source_Codelist_code', 'Target_codelist_code']
  };

  sqlQuery: string = '';

  constructor(private localStorageSettings: LocalStorageSettingsService,private dialogref: MatDialogRef<SqlEditorPopupComponent>,@Inject(MAT_DIALOG_DATA) public data: objectListDialogData) {}
  ngOnInit() {
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }

  generateQuery() {
    if (!this.selectedTables.length) {
      this.sqlQuery = '';
      return;
    }

    let selectClause = this.selectedColumns.length
      ? this.selectedColumns.map(col => (col === this.groupConcatColumn && this.useGroupConcat ? `GROUP_CONCAT(${col}, ',') AS ${col}_CONCAT` : col)).join(', ')
      : '*';

    let query = `SELECT ${selectClause} FROM ${this.selectedTables[0]}`;

    // Handle JOINs
    this.selectedJoins.forEach(join => {
      if (join.table && join.onCondition) {
        query += ` LEFT JOIN ${join.table} ON ${join.onCondition}`;
      }
    });

    // Handle WHERE conditions
    if (this.selectedConditions.length) {
      let whereConditions = this.selectedConditions.map(c => `${c.column} ${c.operator} '${c.value}'`).join(' AND ');
      query += ` WHERE ${whereConditions}`;
    }

    // Handle GROUP BY
    if (this.selectedGroupByColumns.length) {
      query += ` GROUP BY ${this.selectedGroupByColumns.join(', ')}`;
    }

    // Handle UNION queries
    this.selectedUnions.forEach(unionQuery => {
      if (unionQuery.selectedTables.length) {
        let unionSelect = unionQuery.selectedColumns.length
          ? unionQuery.selectedColumns.join(', ')
          : '*';
        let unionSQL = `SELECT '${unionQuery.alias}' AS SOURCE, ${unionSelect} FROM ${unionQuery.selectedTables[0]}`;
        query = `(${query}) UNION (${unionSQL})`;
      }
    });

    // Handle Subqueries
    this.selectedSubqueries.forEach(subquery => {
      if (subquery.selectedTables.length) {
        let subSelect = subquery.selectedColumns.length
          ? subquery.selectedColumns.join(', ')
          : '*';
        let subSQL = `SELECT ${subSelect} FROM ${subquery.selectedTables[0]}`;
        query += ` AND EXISTS (${subSQL})`;
      }
    });

    this.sqlQuery = query;
  }

  executeQuery() {
    // this.http.post('/api/sql/execute', { query: this.sqlQuery }).subscribe(
    //   (response: any) => this.queryResult = response,
    //   error => console.error('Query Error:', error)
    // );
  }

  addCondition() {
    this.selectedConditions.push({ column: '', operator: '=', value: '' });
  }

  addJoin() {
    this.selectedJoins.push({ table: '', onCondition: '' });
  }

  addUnion() {
    this.selectedUnions.push({ selectedTables: [], selectedColumns: [], alias: '' });
  }

  addSubquery() {
    this.selectedSubqueries.push({ selectedTables: [], selectedColumns: [] });
  }
  sqlQueryChange(value){
    this.sqlQuery=value
  }

  closeFunction(){
    this.dialogref.close(null)
  }
  proccedFunction(){
    this.dialogref.close(this.sqlQuery);
  }
}
